import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logoImage from '../../assets/logo2.png';
import './NavBar.css';

const NavBar = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate =useNavigate();

  const flowerCategories = {
    'Bouquets': [
      { name: 'Mixed Bouquets', image: '🌹', description: 'Colorful mixed arrangements' },
      { name: 'Roses', image: '🌹', description: 'Classic rose bouquets' },
      { name: 'Luxury Bouquets', image: '🌺', description: 'Premium flower arrangements' },
      { name: 'Autumn Bouquets', image: '🌻', description: 'Seasonal autumn flowers' },
      { name: 'Spring Bouquets', image: '🌸', description: 'Fresh spring arrangements' }
    ],
    'Occasions': [
      { name: 'Birthday', image: '🎂', description: 'Birthday celebrations' },
      { name: 'Anniversary', image: '💕', description: 'Romantic anniversaries' },
      { name: 'Wedding', image: '💒', description: 'Wedding ceremonies' },
      { name: 'Graduation', image: '🎓', description: 'Academic achievements' },
      { name: 'Valentine\'s Day', image: '💘', description: 'Romantic gestures' }
    ],
    'Morning and Condolence': [
      { name: 'Sympathy Wreaths', image: '🕊️', description: 'Peaceful tributes' },
      { name: 'Memorial Arrangements', image: '🕯️', description: 'Honoring memories' },
      { name: 'Condolence Bouquets', image: '🤍', description: 'Comforting arrangements' },
      { name: 'Funeral Sprays', image: '🌿', description: 'Traditional tributes' }
    ],
    'Abroad': [
      { name: 'International Delivery', image: '🌍', description: 'Worldwide shipping' },
      { name: 'European Delivery', image: '🇪🇺', description: 'European countries' },
      { name: 'Same Day Abroad', image: '✈️', description: 'Express international' }
    ],
    'Funeral Flowers': [
      { name: 'Funeral Wreaths', image: '🕊️', description: 'Traditional wreaths' },
      { name: 'Casket Sprays', image: '🌿', description: 'Casket arrangements' },
      { name: 'Standing Sprays', image: '🕯️', description: 'Standing tributes' },
      { name: 'Sympathy Plants', image: '🌱', description: 'Living memorials' }
    ]
  };

  const handleMouseEnter = (category) => {
    setActiveDropdown(category);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      {/* Top Row - Logo and Main Navigation */}
      <div className="navbar-top">
        <div className="navbar-brand">
          <Link to="/" className="logo">
            <div className="logo-container">
              <img src={logoImage} alt="Tulipink" className="logo-image" />
            </div>
          </Link>
        </div>
        
        <div className="navbar-links">
          <Link 
            to="/inspiration" 
            className={`nav-link ${location.pathname === '/inspiration' ? 'nav-link-active' : ''}`}
          >
            Inspiration
          </Link>
          <Link 
            to="/business" 
            className={`nav-link ${location.pathname === '/business' ? 'nav-link-active' : ''}`}
          >
            Business
          </Link>
          <Link 
            to="/about" 
            className={`nav-link ${location.pathname === '/about' ? 'nav-link-active' : ''}`}
          >
            About us
          </Link>
          <Link 
            to="/customer-service" 
            className={`nav-link ${location.pathname === '/customer-service' ? 'nav-link-active' : ''}`}
          >
            Customer Service
          </Link>
        </div>
        
        <div className="navbar-utils">
          <div className="cart" onClick={() => navigate('/cart')}>
            <svg className="cart-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="9" cy="21" r="1"/>
              <circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            <span className="cart-count" data-count="0">0</span>
          </div>
          
          {/* Hamburger Menu Button */}
          { !isMobileMenuOpen && (
            <button className="hamburger-menu" onClick={toggleMobileMenu}>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          )}
        </div>
      </div>

      {/* Bottom Row - Category Navigation */}
      <div className="navbar-categories">
        <div className="category-links">
          {Object.keys(flowerCategories).map((category) => (
            <div
              key={category}
              className="category-item"
              onMouseEnter={() => handleMouseEnter(category)}
              onMouseLeave={handleMouseLeave}
            >
              <span className="category-link">
                {category}
                <svg className="dropdown-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6,9 12,15 18,9"/>
                </svg>
              </span>
              
              {activeDropdown === category && (
                <div className="dropdown-menu">
                  <div className="dropdown-content">
                    {flowerCategories[category].map((flower, index) => (
                      <div key={index} className="flower-item">
                        <div className="flower-image">
                          <span className="flower-emoji">{flower.image}</span>
                        </div>
                        <div className="flower-info">
                          <h4 className="flower-name">{flower.name}</h4>
                          <p className="flower-description">{flower.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* <div className="delivery-info">
          <span className="delivery-text">Delivery today?</span>
          <div className="countdown">
            <span className="countdown-time">02:47:14</span>
            <span className="countdown-text">hours left</span>
            <span className="clock-icon">🕐</span>
          </div>
        </div> */}
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-menu-content">
            {/* Header with Navigation title and Close Button */}
            <div className="mobile-menu-header">
              <h3>Navigation</h3>
              <button className="mobile-close-btn" onClick={toggleMobileMenu}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            
            {/* Main Navigation Links */}
            <div className="mobile-nav-section">
              <Link 
                to="/inspiration" 
                className={`mobile-nav-link ${location.pathname === '/inspiration' ? 'mobile-nav-link-active' : ''}`}
                onClick={toggleMobileMenu}
              >
                Inspiration
              </Link>
              <Link 
                to="/business" 
                className={`mobile-nav-link ${location.pathname === '/business' ? 'mobile-nav-link-active' : ''}`}
                onClick={toggleMobileMenu}
              >
                Business
              </Link>
              <Link 
                to="/about" 
                className={`mobile-nav-link ${location.pathname === '/about' ? 'mobile-nav-link-active' : ''}`}
                onClick={toggleMobileMenu}
              >
                About us
              </Link>
              <Link 
                to="/customer-service" 
                className={`mobile-nav-link ${location.pathname === '/customer-service' ? 'mobile-nav-link-active' : ''}`}
                onClick={toggleMobileMenu}
              >
                Customer Service
              </Link>
            </div>

            {/* Category Navigation Links */}
            <div className="mobile-nav-section">
              <h3>Categories</h3>
              {Object.keys(flowerCategories).map((category) => (
                <div key={category} className="mobile-category-item">
                  <span className="mobile-category-link">
                    {category}
                  </span>
                  <div className="mobile-category-dropdown">
                    {flowerCategories[category].map((flower, index) => (
                      <div key={index} className="mobile-flower-item" onClick={toggleMobileMenu}>
                        <span className="mobile-flower-emoji">{flower.image}</span>
                        <div className="mobile-flower-info">
                          <span className="mobile-flower-name">{flower.name}</span>
                          <span className="mobile-flower-description">{flower.description}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavBar;